import UserContractVersionNameQuery from '@/api/user_contract/user_contract_version_name/query.js';

export const userContractVersion = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    userContractVersionList: []
  },
  getters: {
    userContractVersionList: state => state.userContractVersionList
  },
  mutations: {
    setUserContractVersionList(state, userContractVersionList) {
      state.userContractVersionList = userContractVersionList;
    },
    clear(state) {
      state.userContractVersionList = [];
    }
  },
  actions: {
    setUserContractVersionList({ commit }, payload) {
      UserContractVersionNameQuery.getUserContractHeadInfoListForAllVersions(payload).then(res => {
        commit('setUserContractVersionList', res.data.data);
      });
    },
    clearUserContractVersionList({ commit }) {
      commit('clear');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user_contract_version.js